module.exports = __webpack_public_path__ + "img/pointer-4.png";